import { useCurrentUser } from 'app/agriculture/hooks/users/useCurrentUser';
import { ProfileAvatar } from 'app/agriculture/infobox/common/ProfileAvatar';
import { useNavigate } from 'react-router-dom';
import { PopoverMenu } from 'app/agriculture/components/PopoverMenu/PopoverMenu';
import { logout } from 'app/agriculture/FarmMain/TopBar/logout';

export function ProfileWidget() {
    const { name } = useCurrentUser();
    const navigate = useNavigate();

    return (
        <PopoverMenu
            trigger={{
                text: name,
                variant: 'textonly',
                startIcon: <ProfileAvatar name={name} size={32} />,
            }}
            items={[
                {
                    text: 'Edit Profile',
                    startIcon: 'edit',
                    onClick: () => {
                        navigate('profile');
                    },
                },
                {
                    text: 'Logout',
                    startIcon: 'logout',
                    onClick: () => {
                        void logout();
                    },
                },
            ]}
        />
    );
}
